import { render } from "./WorkbookContent.vue?vue&type=template&id=67f1a0ce"
import script from "./WorkbookContent.vue?vue&type=script&lang=js"
export * from "./WorkbookContent.vue?vue&type=script&lang=js"

import "./WorkbookContent.vue?vue&type=style&index=0&id=67f1a0ce&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__